export const REGISTRATION_ACTIONS = {
  RESET_FORM_VALUES: 'RESET_FORM_VALUES',
  SET_FORM_VALUES: 'SET_FORM_VALUES',
  SET_HOME_FORM_VALUES: 'SET_HOME_FORM_VALUES',
};
